import { useState, useEffect } from 'react';
import api, { fetchCourseDetails, fetchProfessorDetails, fetchProfessorSubmissionDetails } from '../services/api';
import { formatPrevSubmission } from './formatPrevSubmission';

export default function usePrevSubmissionDisplay(prev) {
  const [text, setText] = useState('N/A');
  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      if (!prev || (typeof prev === 'object' && Object.keys(prev).length === 0)) {
        if (isMounted) setText('N/A');
        return;
      }
      let obj = { ...prev };
      try {
        if (typeof prev.course === 'number') {
          const data = await fetchCourseDetails(prev.course);
          obj.course = data;
        }
      } catch {}
      try {
        if (typeof prev.professor === 'number') {
          const data = await fetchProfessorDetails(prev.professor);
          obj.professor = data;
        } else if (typeof prev.professor_submission === 'number') {
          const data = await fetchProfessorSubmissionDetails(prev.professor_submission);
          obj.professor = { name: data.name };
          delete obj.professor_submission;
        }
      } catch {}
      if (isMounted) setText(formatPrevSubmission(obj));
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [prev]);
  return text;
}
